var _circle, _defs, _rect, _image, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEndpointDiamond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 -10 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 42.5,
    cy: 42.5,
    r: 52.5,
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-11 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: #007676;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.7,
    y: 28,
    width: 41,
    height: 29
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.9,41.1v-11.4h-28.7v1.3h3.7c1.1,0,2,.9,2,2.1v17.2h23v-2.7h1.6v2.7c0,.9-.7,1.7-1.6,1.7h-11.9v1.7h3.7c.5,0,.8.4.8.8s-.4.8-.8.8h-12.3c-.5,0-.8-.4-.8-.8s.4-.8.8-.8h3.7v-1.7h-6.2v3.4c0,.9-.7,1.7-1.6,1.7h-9c-.9,0-1.6-.8-1.6-1.7v-22.7c0-.9.7-1.7,1.6-1.7h3.3v-1.3c0-.9.7-1.7,1.6-1.7h28.7c.9,0,1.6.8,1.6,1.7v10.6s-1.6.8-1.6.8ZM42.8,53.7h1.6v-1.7h-1.6v1.7ZM24.3,55.4h9v-22.7h-9v22.7ZM26,34.3h5.7c.5,0,.8.4.8.8s-.4.8-.8.8h-5.7c-.5,0-.8-.4-.8-.8s.4-.8.8-.8ZM28.8,49.5c-1.8,0-3.3-1.5-3.3-3.4s1.5-3.4,3.3-3.4,3.3,1.5,3.3,3.4-1.5,3.4-3.3,3.4ZM28.8,47.8c.9,0,1.6-.8,1.6-1.7s-.7-1.7-1.6-1.7-1.6.8-1.6,1.7.7,1.7,1.6,1.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.9,
    y: 14,
    width: 70,
    height: 57
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.5,40.5h-23c-1.2,0-2.2.9-2.2,2.1v4.2c0,1.1,1,2.1,2.2,2.1h23c1.2,0,2.2-.9,2.2-2.1v-4.2c0-1.1-1-2.1-2.2-2.1ZM62.2,46.7c0,.4-.3.7-.7.7h-23c-.4,0-.7-.3-.7-.7v-4.2c0-.4.3-.7.7-.7h23c.4,0,.7.3.7.7v4.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.9,
    y: 14,
    width: 70,
    height: 57
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.8,43.9c0,.4-.3.7-.7.7s-.7-.3-.7-.7.3-.7.7-.7.7.3.7.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.9,
    y: 14,
    width: 70,
    height: 57
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.6,
    y: 15.1,
    width: 54.9,
    height: 54.9,
    transform: "translate(-17.7 42.2) rotate(-45)"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    className: "cls-11",
    width: 71,
    height: 58,
    transform: "translate(8 14) scale(1)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAA6CAYAAADiDEQAAAAACXBIWXMAAAs6AAALOgFkf1cNAAAEW0lEQVR4nO1by5KjMAwUU/P/n7zew2woR+lWtwTJXFZVKYyxXo0k2wQi/hOl4w4ha61b5LyLjuNYI74J00Uw7gBy5GxED6i2oU1gPhlRLcAckCzjTUDUmE9GjDVOAVQabICCrv9G/WFO6ugoAJqCk/vV+TuoA0gdIQSgb6rZA4a1qz5Fbupk2Sv1rzS2XcSh8QQYBxQFlqKuA070sPYToeh5caABTNVXyRjXBzE297UAkuAYqeQcJ8Coax1eBlIJEAKH1pydrziydubN58gBBGquGx3aa9DajpHalE6FIp0YMBU4ypl2XRAy9vMqWtC1ceSc/NuRgcOAuWMGQWOrG5CjBfGW+itwVHFVYCFellYOUGzq3s8ZWDtQUNda68jR40YOK7gZmCp6KsrGo+vMpp3faUugHsTAYcXV/SEZ1RSegUGR5VAliwFCAerMVvs5+n2l65nXSZ28ys39lY0sMpiMSzUnC1IpxfoYoTu692f9SlYFxC6HApLrzhcY49SMTmpV4LEI6xK7aegc6TjP9yXNd+4wlVbOqqKMii4rovt1ZhvacLrpNCrIWRhCXRXrPEZRBYqK4iyj4pPAPNKrswhEBqkUQjy7gfk6m6XUNqJTvxy9EaGn8tznpF811lmo5T5mT6W/0pNlU5pETo6MqhgyXnYt74W6xfm2qIl4BYdVdOUsA0RFgrOyjaIPyUUp2NnDnXS15rhjUC1QEdZxSM1UavaDIE5WyGqsG30rftZZnQVbBZrcKwFbLq2QnSm0qj1IBkufrmNIJkvbdlqttY5uWnULpFOHrhCqNfYiTxHaPnyKUHR1F5F3Av1CXXDGd+EfoSLM0hMBVhVxZOMle6ezVZeq1bLiY0/83NR5W1o5SuED64acCJxOTkRV+txnR9Q+J60QIwNk73cMZNuOCSCKVvh2RcSsIDOwVAR1w9sFhDmbb1RP+XEsFxw3ejJI2bBJ/rtgo8i4lFq5IFf7G/RYABmBrudrI2MDgz39VXoigs9WzqMFtANGGz+kHIGOzlkUOo6r+iKj2JnK85L80ecC4chmfRNwMh8ab1FnnVMBwYBhEejWAlRUHWD+JFkOeC+kwFHOPUBRwKBUZPpyu7r7V1LLS6vjOJZ4ObLKW/YEj+2MO3qQo3u7A1yl44ke/12hyHHvchbMQIl0nKRUPjqgoDbTAcktyM4UzAq2GzU7b25XKRairWQ+0f6Pp5rKmZNobMUbBT/Tn9vKedRG/Ll90vQVlEwVSFeBQXq6qcb4c/uk7ptdVfRUq18FTLcgs7aTOlVbkhs5k/TKBlkPtckYpw5V7VIve4P9yZnhO8hO/5QmjtuR0vow5I2v9HdAYlF55fzVIOOTom5a7YpZLZkU3l1P5/pbQDnHvmivV8qdqJiklFpLdXl+DLnzM8bhd1ZVv0OTQv1qwBAIKItacc/XeVep7ehHwImwAbLlIRXN8VzxjaCcMtWA3/4s+h1O27q7DHeD9ZvOK/oLejhojR7BBI8AAAAASUVORK5CYII="
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.9,
    y: 14,
    width: 70,
    height: 57
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 21.7,
    y: 27,
    width: 38.9,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 35.3,
    y: 39.5,
    width: 29.3,
    height: 10.3
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 39.4,
    y: 42.2,
    width: 3.4,
    height: 3.4
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndpointDiamond);
export default __webpack_public_path__ + "static/media/endpoint-diamond.f250fabaf8fff1fc1bd42cfc521762b0.svg";
export { ForwardRef as ReactComponent };